export default __webpack_public_path__ + "static/media/middleman.37314131.png";